const config = require("config");

(function () {
  var serviceId = "routingProfile";

  angular
    .module("app")
    .factory(serviceId, ["$rootScope", "$q", "_", "$http", "systemDefaultOptions", "UserProvider", "conversionService", "applicationSettingsService",
      function routeService($rootScope, $q, _, $http, systemDefaultOptions, userProvider, conversionService, applicationSettingsService) {
        var defaultOptions;

        // Note: change this when PCM38 becomes base data.
        var BASE_DATA = "PCM37";

        var daVehicleType = {
          Auto: 0,
          Truck: 3,
          MidsizeTruck: 12,
          LightDuty: 11
        };

        var pcmVehicleType = {
          Truck: 0,
          LightTruck: 1,
          Car: 2
        };

        // eslint-disable-next-line complexity
        function getPCMRouteOptionsFromDA(options) {
          /*da options. {
            "VehicleGroups": [ ],
            "displayRestrictions": 0,
            "ferryClosed": false,
            "propane": false,
            "revision": "January, 2015",
            "totalWeightPerAxle": 0,
            "truckDimensions": 0,
          }*/
          var pcmOptions = {
            routingProfileId: options.routingProfileId, //added this field since Id is needed
            name: options.name,
            trkUnits: options.unitsOfMeasure,
            trkWeight: options.totalWeight,
            trkAxles: options.numAxles,
            trkLCV: options.LCV,
            routingType: options.routingType,
            distanceUnits: options.distanceUnits,
            tollDiscourage: options.tollDiscouraged,
            tollRoadType: options.tollRoadType,
            bordersOpen: options.bordersOpen,
            overrideRestrict: options.overrideRestrictions,
            highwayOnly: options.highwayOnly,
            inclFerryDist: options.includeFerryDistance,
            hazMatType: options.hazmatType,
            tollCurrency: options.tollCurrency,
            exchangeRate: parseFloat(options.exchangeRate),
            hubRouting: options.hubRouting,
            fuelUnits: options.fuelUnits,
            costGHG: parseFloat(options.costGHG),
            costPerFuelUnit: parseFloat(options.costPerFuelUnit),
            fuelEconLoad: parseFloat(options.fuelEconomyLoad),
            fuelEconEmpty: parseFloat(options.fuelEconomyEmpty),
            costMaintLoad: parseFloat(options.costMaintLoad),
            costMaintEmpty: parseFloat(options.costMaintEmpty),
            costTimeLoad: parseFloat(options.costTimeLoad),
            costTimeEmpty: parseFloat(options.costTimeEmpty),
            dataVersion: options.dataVersion,
            inclTollData: options.includeTollData,
            tollPlan: options.includeTollData ? options.tollDiscountPlans : "",
            ferryDiscourage: options.isFerryDiscouraged,
            useSites: options.useSites || false,
            elevLimit: userProvider.getUser().isPremium() ? options.elevationLimit : null,
            governorSpeedLimit: options.governorSpeedLimit,
            sideOfStreetAdherence: (options.sideOfStreetAdherence) ? options.sideOfStreetAdherence : 0,
            EUOptions : {
              fuelType: options.euProfile.fuelType !== null ? options.euProfile.fuelType : undefined,
              refrigerated: options.euProfile.refrigerated !== null ? options.euProfile.refrigerated : undefined ,
              fuelConsumption: options.euProfile.fuelConsumption !== null ? options.euProfile.fuelConsumption : undefined,
              emiType: options.euProfile.emiType !== null ? options.euProfile.emiType : undefined,
              hasTrailer: options.euProfile.hasTrailer !== null ? options.euProfile.hasTrailer : undefined,
              isHybrid: options.euProfile.isHybrid !== null ? options.euProfile.isHybrid : undefined,
              minPoll: options.euProfile.minPoll !== null ? options.euProfile.minPoll : undefined,
              trlCount: options.euProfile.trailerCount !== null ? options.euProfile.trailerCount : undefined,
              trlMaxAxles: options.euProfile.trailerMaxAxles !== null ? options.euProfile.trailerMaxAxles : undefined,
              trlType: options.euProfile.trailerType !== null ? options.euProfile.trailerType : undefined,
              trlMaxWt: options.euProfile.trailerMaxWt !== null ? options.euProfile.trailerMaxWt : undefined
            }
          };

          // vehicle types in dataanywhere are different from what is in the UI.  Use this mapping.
          // vehicle groups which are not light duty, auto, or truck are filtered out before this.
          if (options.vehicleType === daVehicleType.LightDuty) {
            pcmOptions.vehicleType = pcmVehicleType.LightTruck;

          } else if (options.vehicleType === daVehicleType.Auto) {
            pcmOptions.vehicleType = pcmVehicleType.Car;

          } else {
            pcmOptions.vehicleType = pcmVehicleType.Truck;

          }

          // For new customers, only use unitOfMeasure; for existing customer, fix governorSpeedLimit and elevLimit if 2 units are different.
          if (options.unitsOfMeasure === 0 && options.distanceUnits === 1) {
            pcmOptions.governorSpeedLimit = (pcmOptions.governorSpeedLimit == null) ? null : Math.floor(pcmOptions.governorSpeedLimit / 1.61);
            pcmOptions.elevLimit = (pcmOptions.elevLimit == null) ? null : Math.floor(pcmOptions.elevLimit / 1.61);
            pcmOptions.distanceUnits = 0;
          }
          if (options.unitsOfMeasure === 1 && options.distanceUnits === 0) {
            pcmOptions.governorSpeedLimit = (pcmOptions.governorSpeedLimit == null) ? null : Math.floor(pcmOptions.governorSpeedLimit * 1.61);
            pcmOptions.elevLimit = (pcmOptions.elevLimit == null) ? null : Math.floor(pcmOptions.elevLimit * 1.61);
            pcmOptions.distanceUnits = 1;
          }

          if (options.unitsOfMeasure === 0) {
            //English
            pcmOptions.trkLength = conversionService.totalInchesToString(options.totalLength);
            pcmOptions.trkWidth = conversionService.totalInchesToString(options.maxWidth, true);
            pcmOptions.trkHeight = conversionService.totalInchesToString(options.maxHeight);

            if (options.euProfile.trailerMaxHt) {
              pcmOptions.EUOptions.trlMaxHt = conversionService.totalInchesToString(options.euProfile.trailerMaxHt);
            }
          } else if (options.unitsOfMeasure === 1) {
            // Metric
            pcmOptions.trkLength = options.totalLength.toString();
            pcmOptions.trkWidth = options.maxWidth.toString();
            pcmOptions.trkHeight = options.maxHeight.toString();
            if (options.euProfile.trailerMaxHt) {
              pcmOptions.EUOptions.trlMaxHt = options.euProfile.trailerMaxHt.toString();
            }
          }

          // we only want classOverrides 0(None) or 3(fiftyThreeFootTrailer + nationalNetwork) to be consistent with PCM UI.
          if (options.classOverrides > 0) {
            pcmOptions.classOverrides = 3;
          } else {
            pcmOptions.classOverrides = 0;
          }

          return pcmOptions;
        }

        function getDARouteOptionsFromPCM(options) {
          var daOptions = {
            LCV: options.trkLCV,
            VehicleGroups: [],
            classOverrides: (options.classOverrides === 3) ? 3 : 0,
            costGHG: options.costGHG.toString(),
            costMaintEmpty: options.costMaintEmpty.toString(),
            costMaintLoad: options.costMaintLoad.toString(),
            costPerFuelUnit: options.costPerFuelUnit.toString(),
            costTimeEmpty: options.costTimeEmpty.toString(),
            costTimeLoad: options.costTimeLoad.toString(),
            dataVersion: options.dataVersion,
            //displayRestrictions: 1,
            distanceUnits: options.distanceUnits,
            exchangeRate: options.exchangeRate.toString(),
            //ferryClosed: false,
            fiftyThreeFootTrailer: options.classOverrides === 3,
            fuelEconomyEmpty: options.fuelEconEmpty.toString(),
            fuelEconomyLoad: options.fuelEconLoad.toString(),
            fuelUnits: options.fuelUnits,
            hazmatType: options.hazMatType,
            highwayOnly: options.highwayOnly,
            includeFerryDistance: options.inclFerryDist,
            nationalNetwork: options.classOverrides === 3,
            numAxles: options.trkAxles,
            //propane: true,
            routingProfileId: options.routingProfileId,
            tollCurrency: options.tollCurrency,
            tollDiscouraged: options.tollDiscourage,
            tollRoadType: options.tollRoadType,
            totalWeight: options.trkWeight,
            //totalWeightPerAxle: 0,
            truckDimensions: 16,
            unitsOfMeasure: options.trkUnits,
            name: options.name,
            bordersOpen: options.bordersOpen,
            routingType: options.routingType,
            overrideRestrictions: options.overrideRestrict,
            hubRouting: options.hubRouting,
            includeTollData: options.inclTollData,
            tollDiscountPlans: options.inclTollData ? options.tollPlan : "", // if toll data is false, put empty string.
            elevationLimit: options.elevLimit,
            isFerryDiscouraged: options.ferryDiscourage,
            useSites: options.useSites,
            governorSpeedLimit: options.governorSpeedLimit,
            sideOfStreetAdherence: options.sideOfStreetAdherence,
            euProfile: {
              fuelType: options.EUOptions.fuelType,
              refrigerated: options.EUOptions.refrigerated,
              fuelConsumption: options.EUOptions.fuelConsumption,
              emiType: options.EUOptions.emiType,
              hasTrailer: options.EUOptions.hasTrailer,
              isHybrid: options.EUOptions.isHybrid,
              minPoll: options.EUOptions.minPoll,
              trailerCount: options.EUOptions.trlCount,
              trailerMaxAxles: options.EUOptions.trlMaxAxles,
              trailerType: options.EUOptions.trlType,
              trailerMaxWt: options.EUOptions.trlMaxWt
            }
          };

          // vehicle types in dataanywhere are different from what is in the UI.  Use this mapping.
          if (options.vehicleType === pcmVehicleType.Car) {
            daOptions.vehicleType = daVehicleType.Auto;
          } else if (options.vehicleType === pcmVehicleType.LightTruck) {
            daOptions.vehicleType = daVehicleType.LightDuty;
          } else {
            daOptions.vehicleType = daVehicleType.Truck;
          }

          if (options.trkUnits === 0) {
            // english units.
            daOptions.maxHeight = conversionService.stringToTotalInches(options.trkHeight);
            daOptions.maxWidth = conversionService.stringToTotalInches(options.trkWidth);
            daOptions.totalLength = conversionService.stringToTotalInches(options.trkLength);
            if (options.EUOptions.trlMaxHt) {
              if ( userProvider.getUser().region === "EU") {
                daOptions.euProfile.trailerMaxHt = conversionService.stringToTotalInches(options.EUOptions.trlMaxHt);
              } else {
                daOptions.euProfile.trailerMaxHt = daOptions.maxHeight;
              }
              
            }
          } else {
            // metric untis
            daOptions.maxHeight = options.trkHeight;
            daOptions.maxWidth = parseFloat(options.trkWidth);
            daOptions.totalLength = options.trkLength;
            if (options.EUOptions.trlMaxHt) {
              if ( userProvider.getUser().region === "EU") {
                daOptions.euProfile.trailerMaxHt = options.EUOptions.trlMaxHt;
              } else {
                daOptions.euProfile.trailerMaxHt = daOptions.maxHeight;
              }
            }
            
          }

          return daOptions;
        }

        /**
         * Only display certain routing profiles.
         * Don't want to display ones that are deleted.
         * Also, don't want to display ones that have options that are not valid for pcmiler web ui (example: a vehicle type of medium)
         */
        function isValidPCMilerWebUIProfile(item) {
          if (item.statusDeleted) return false;

          if (item.vehicleType != daVehicleType.Auto && item.vehicleType != daVehicleType.LightDuty && item.vehicleType != daVehicleType.Truck) return false;

          return true;
        }

        function getDefaultOptionsFromService() {
          var deferred = $q.defer();

          $http.get(config.daUrl + "routing-profiles/default")
            .success((options) => {
              // Only want the route options which are not explicitly deleted (if the statusDeleted column doesnt come back or if it is false, we assume the rout eoption is not deleted)
              options = options || [];
              var option = _.find(options, (item) => {
                return isValidPCMilerWebUIProfile(item);
              });

              // Copy object to make changes and not alter defaults so we don't break logout/change subcription level
              var sdo = getSystemDefaultOptions();

              // SWPWEB-8 - Initially enable toll data for Premium users. Saved defaults will overide this value.
              if (userProvider.getUser().isPremium()) {
                sdo.inclTollData = true;
              }

              if (option) {
                var pcmOptions = getPCMRouteOptionsFromDA(option);

                // Clear saved toll enabling from downgraded account
                if (!userProvider.getUser().isPremium()) {
                  pcmOptions.inclTollData = false;
                }

                pcmOptions.afSetIDs = applicationSettingsService.getUserCfg("afSetIDs") || "";
                if (userProvider.getUser().region === "EU") {
                  pcmOptions.EUOptions = _.defaults(pcmOptions.EUOptions, sdo.EUOptions);
                }

                if (userProvider.getUser().region !== "EU" && !userProvider.getUser().isPremium()) {
                  pcmOptions.dataVersion = BASE_DATA;
                }

                deferred.resolve(_.defaults(pcmOptions, sdo));
              } else {
                var daOptions = getDARouteOptionsFromPCM(sdo);
                daOptions.default = true;

                $http.post(config.daUrl + "routing-profiles", daOptions)
                  .success((newDefaultRoutingProfile) => {
                    deferred.resolve(_.defaults({
                      routingProfileId: newDefaultRoutingProfile.Id
                    }, sdo));
                  })
                  .error((err) => {
                    deferred.reject(err);
                  });
              }
            })
            .error((err) => {
              deferred.reject(err);
            });

          return deferred.promise;
        }

        // currently, most routing profile options can be retrieved from DA service, some options like afsetId and EU options are saved in browser localStorage.
        function getSystemDefaultOptions() {
          var temp = angular.copy(systemDefaultOptions);

          if (!(userProvider.getUser().subscriptionLevel === "Premium" || userProvider.getUser().subscriptionLevel === "Trial")) {
            temp.highwayOnly = true;
          }

          if (userProvider.getUser().region === "EU") {
            temp.tollCurrency = 11; // EUR Currency
            temp.exchangeRate = 1;
            temp.dataVersion = "PCM_EU";
          } else if (!userProvider.getUser().isPremium()) { // SWPWEB-728 standard customers can only get access to base data.
            temp.dataVersion = BASE_DATA;
          }
          return temp;
        }

        function getDefaultOptionsPromise() {
          var defaultOptionsPromise = $q.defer();

          if (userProvider.getUser().isLoggedIn !== true) {
            defaultOptionsPromise.reject({
              message: "not logged in"
            });
            return defaultOptionsPromise.promise;
          }

          // if we already have default options retrieved from the service, use those.  If the options we currently have were our system default options because the service was down, try to get the options again from the service.
          if (defaultOptions != null && !defaultOptions.routingProfileNotAvailable) {
            defaultOptionsPromise.resolve(defaultOptions);
          } else {
            getDefaultOptionsFromService().then(function (resp) {
              defaultOptions = resp;
              defaultOptionsPromise.resolve(resp);
            }, function (err) {
              // If there is an error getting the default routing profile, use the system default options instead.
              // The user will have to log out and back in again to check again for their actual routing profile.
              var sdo = getSystemDefaultOptions();
              sdo.routingProfileNotAvailable = true;
              defaultOptions = sdo;
              defaultOptionsPromise.resolve(sdo);
            });
          }

          return defaultOptionsPromise.promise;
        }

        function getDefaultOptions() {
          return defaultOptions;
        }

        // currently, most routing profile options can be retrieved from DA service, some options like afsetId and EU options are saved in browser localStorage.
        function setDefaultOptions(options) {
          var copiedOptions = angular.copy(options);

          // when saving other options as defaults, set the name to "Default" (so we can retrieve it by name next time), and the routing profile id (so we update the correct item).
          copiedOptions.name = "Default";
          copiedOptions.routingProfileId = defaultOptions.routingProfileId;

          var daOptions = getDARouteOptionsFromPCM(copiedOptions);
          daOptions.default = true;

          defaultOptions = copiedOptions;

          // save some options to localStorage.
          var tempOptions = {};
          tempOptions.afSetIDs = copiedOptions.afSetIDs;
          if (userProvider.getUser().region === "EU") {
            tempOptions.options = copiedOptions.EUOptions;
          }
          applicationSettingsService.updateUserCfg(tempOptions);

          return $http.put(config.daUrl + "routing-profiles/" + daOptions.routingProfileId, daOptions); // jshint ignore:line
        }

        // whenever a user is loaded, get the data for them.
        $rootScope.$on("UserLoggedIn", function (event, message) { // jshint ignore:line
          defaultOptions = null;
        });

        var service = {
          getPCMRouteOptionsFromDA: getPCMRouteOptionsFromDA,
          getDARouteOptionsFromPCM: getDARouteOptionsFromPCM,
          setDefaultOptions: setDefaultOptions,
          getDefaultOptions: getDefaultOptions,
          getDefaultOptionsPromise: getDefaultOptionsPromise,
          getSystemDefaultOptions: getSystemDefaultOptions
        };

        return service;
      }
    ]);
})();



// WEBPACK FOOTER //
// ./app/route/routingProfile.service.js